import { Category } from "./category.model";
import { IProduct } from "./product.model";
import { IProductTypeCharacteristic } from "./productTypeCharacteristic.model";
import { IService } from "./service.model";

export interface IProductType{
  id?: number;
  name?: string;
  category?: Category;
  productTypeCharacteristics?: IProductTypeCharacteristic[];
  type?: string;
  slug?: string;
  services?: IService[];
  products?: IProduct[];
}

export class ProductType implements IProductType{
  constructor(
    public id?: number,
    public name?: string,
    public category?: Category,
    public productTypeCharacteristics?: IProductTypeCharacteristic[],
    public type?: string,
    public slug?: string,
    public services?: IService[],
    public products?: IProduct[],
  ){
    this.id = id;
    this.name = name;
    this.category = category;
    this.productTypeCharacteristics = productTypeCharacteristics;
    this.type = type;
    this.slug = slug;
    this.services = services;
    this.products = products;
  }
}
